import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from "react-redux";
import { breadcrumbsActions, customersActions as myActions } from "../../../_services/essentials/store";
import useScreenSize from "../../../_components/UserScreenSize";

import Grid from "@mui/material/Grid2";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import GroupIcon from '@mui/icons-material/Group';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Pagination from '@mui/material/Pagination';
import ViewHeadlineRoundedIcon from '@mui/icons-material/ViewHeadlineRounded';
import { history } from "../../../_services/essentials/helpers";
import { Authorization } from "../../../_components/Authorization";
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';

export { List };

function List() {
    //    const entity_name = "customer";
    //    const entity_label = "Customer";
    const entities_name = "customers";
    const entities_label = "Customers";

    const listAPIResponse = useSelector(x => x.customers?.listAPIResponse);
    // const entities = listAPIResponse?.value?.list;
    // const totalPages = listAPIResponse?.value?.totalPages;
    // const listAPIResponse = useSelector(x => x.users?.listAPIResponse);

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');

    useEffect(() => {
        if (listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setLoading(false);
        }
    }, [listAPIResponse]);
    //    const totalItems = listAPIResponse?.value?.totalItems;
    const dispatch = useDispatch();

    const screenSize = useScreenSize();

    // const [dataFilter, setDataFilter] = useState({
    //     "customerFilter": {
    //     }
    // });
    const dataFilter = {
        "customerFilter": {
        }
    };

    const [sortModel, setSortModel] = React.useState([
        {
            field: 'organizationName',
            sort: 'asc',
        }
    ]);

    const [pageFilter, setPageFilter] = useState({
        "pageNumber": 1,
        "pageSize": 50,
        sortField: sortModel[0]?.field || 'organizationName',
        sortDirection: sortModel[0]?.sort || 'asc',
        "dataFilter": dataFilter
    });

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
        dispatch(myActions.getPaginatedList(pageFilter));
    }, [dispatch, pageFilter]);

    const updatePageFilter = (updates = {}) => {
        setLoading(true);
        setPageFilter((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    // useEffect(() => {
    //     setPageFilter({
    //         ...pageFilter,
    //         pageNumber: 1,
    //         pageSize: 50,
    //         sortField: sortModel[0]?.field,
    //         sortDirection: sortModel[0]?.sort,
    //     });
    // }, [sortModel]);

    function navigatePage(event, newPageNumber) {
        setLoading(true);
        setPageFilter({
            ...pageFilter, // copy the current properties of "json"
            "pageNumber": newPageNumber // update the "name" property
        });
    }

    function showDetails(selectedId) {
        history.navigate(`/${entities_name}/edit/${selectedId}`);
    }

    const columns = [
        {
            field: 'id',
            renderHeader: () => (<h6><strong>{'#'}</strong></h6>),
            flex: 1,
            minWidth: 60,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params.row.id)} >{params.value}</Typography>
        },
        {
            field: 'organizationName',
            renderHeader: () => (<h6><strong>{'Organization Name'}</strong></h6>),
            flex: 1,
            minWidth: 280,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params.row.id)} >{params.value}</Typography>
        },
        {
            field: 'websiteURL',
            renderHeader: () => (<h6><strong>{'Website'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 260,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params.row.id)} >{params.value}</Typography>
        },
        {
            field: 'actions',
            renderHeader: () => (<h6><strong>{'Actions'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params) => (
                <Stack direction="row" spacing={2} sx={{ mb: 0.5, mt: 0.5, justifyContent: 'right' }} >
                    <Button variant="outlined" size="small" endIcon={<EditNoteIcon />}
                        onClick={() => history.navigate(`/${entities_name}/edit/${params.row.id}`)}>
                        {/* href={`/${entities_name}/edit/${params.row.id}`} > */}
                        Edit
                    </Button>
                    <Button variant="outlined" sx={{ width: 150 }} size="small" endIcon={<GroupIcon />}
                        onClick={() => history.navigate(`/users/customer/${params.row.id}`)}>

                        {/* href={`/users/customer/${params.row.id}`}> */}
                        View Users
                    </Button>
                    {/*<Button variant="outlined" color="secondary" size="small" startIcon={<DeleteIcon />} onClick={() => handleDelete(params.row.id)}>*/}
                    {/*    Delete*/}
                    {/*</Button>*/}
                </Stack>
            )
        }
    ];

    return (
        <Authorization for={["ROLE_ADMIN", "ROLE_SUPER_ADMIN"]}>
            {/* <Stack
                sx={{
                    ml: 2,
                    // alignItems: 'center',
                }}
            > */}
            <Box sx={{ width: '100%', minWidth: { sm: '100%', } }}>
                <Stack direction="column" sx={{ flexGrow: '1', gap: 1, ml: 2 }} spacing={2} >
                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1, justifyContent: 'right' }} spacing={4}   >
                        {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        <ArrowLeftIcon onClick={() => history.navigate(-1)} sx={{fontSize: '48px', mb:0.5, cursor: 'pointer'}} />{entities_label}
                    </Typography> */}

                        <Typography component="h2" variant="h6" sx={{}}>
                            <Button onClick={() => history.navigate(`/${entities_name}/add`)} variant="contained"
                                color="primary" size="small" endIcon={<AddIcon />}>
                                Add New Customer
                            </Button>
                        </Typography>
                    </Stack>
                    <Stack direction="column" sx={{ flexGrow: '1', gap: 1 }} >
                        <Grid container spacing={2} columns={12}>
                            <Grid size={{ md: 12, lg: 12 }}>
                                {(screenSize.screen === 'web') ? (
                                    <DataGrid
                                        autoHeight
                                        // rowHeight={42}
                                        // checkboxSelection
                                        disableColumnFilter
                                        disableColumnMenu
                                        disableColumnSelector
                                        disableColumnResize
                                        hideFooterPagination={true}
                                        rows={entities}
                                        columns={columns}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                        }
                                        loading={loading}
                                        components={{
                                            LoadingOverlay: CircularProgress,
                                        }}
                                        sx={{
                                            border: 0,
                                            '& .MuiDataGrid-topContainer': {
                                                color: '#fff', // Text color
                                                // border: 0
                                            },
                                        }}
                                        sortingMode="server"
                                        sortingOrder={['asc', 'desc']}
                                        sortModel={sortModel}
                                        onSortModelChange={(newSortModel) => {
                                            setLoading(true);
                                            setSortModel(newSortModel);
                                            updatePageFilter({
                                                sortField: newSortModel[0]?.field,
                                                sortDirection: newSortModel[0]?.sort,
                                                pageNumber: 1
                                            });


                                        }}
                                        initialState={{
                                        }}
                                        slotProps={{
                                            // filterPanel: {
                                            //     filterFormProps: {
                                            //         logicOperatorInputProps: {
                                            //             variant: 'outlined',
                                            //             size: 'small',
                                            //         },
                                            //         columnInputProps: {
                                            //             variant: 'outlined',
                                            //             size: 'small',
                                            //             sx: { mt: 'auto' },
                                            //         },
                                            //         operatorInputProps: {
                                            //             variant: 'outlined',
                                            //             size: 'small',
                                            //             sx: { mt: 'auto' },
                                            //         },
                                            //         valueInputProps: {
                                            //             InputComponentProps: {
                                            //                 variant: 'outlined',
                                            //                 size: 'small',
                                            //             },
                                            //         },
                                            //     },
                                            // },
                                        }}
                                    />
                                ) : (
                                    <Grid
                                        container
                                        spacing={2}
                                        columns={12}
                                        sx={{ mb: (theme) => theme.spacing(2) }}
                                    >
                                        {entities?.map((entity, index) => (
                                            <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
                                                <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
                                                    <CardContent>
                                                        <Typography component="h2" variant="subtitle2" gutterBottom>
                                                            <Button
                                                                variant="link"
                                                                color="primary"
                                                                startIcon={<ViewHeadlineRoundedIcon />}
                                                                href={`/${entities_name}/edit/${entity.id}`}
                                                            />
                                                            {entity.organizationName}
                                                        </Typography>

                                                        <Stack
                                                            direction="column"
                                                            sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
                                                        >
                                                            <Stack sx={{ justifyContent: 'space-between' }}>
                                                                <Stack
                                                                    direction="row"
                                                                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                                                                >
                                                                    <Typography variant="h6" component="p">
                                                                        {entity.organizationName}
                                                                    </Typography>
                                                                </Stack>
                                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                                    {entity.websiteURL}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        {(totalPages > 1) &&
                            <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
                        }
                    </Stack>
                </Stack>
            </Box>
            {/* </Stack> */}
        </Authorization>
    );
}
